import { useMemo } from "react";

import { useOraclePrices, UserExternalRewardsInfoExpanded } from "@bridgesplit/abf-react";
import { Row, Column, Text, repeatElement } from "@bridgesplit/ui";
import { formatTokenAmount, formatUsd } from "@bridgesplit/utils";
import { TokenImage } from "app/components/common";

import { VaultExternalRewardsClaimCta } from "./VaultExternalRewardsClaimCta";
import { useVaultContext } from "../VaultContext";

export function VaultDetailExternalRewards() {
    const { userExternalRewardsPosition } = useVaultContext();

    if (!userExternalRewardsPosition) {
        return <>{repeatElement(<ExternalRewardsClaimDetails reward={undefined} />, 2)}</>;
    }

    return (
        <>
            {Object.entries(userExternalRewardsPosition).map(([, rewards]) =>
                Object.entries(rewards).map(([rewardMint, reward], i) => (
                    <ExternalRewardsClaimDetails key={`${rewardMint}-${i}`} reward={reward} />
                ))
            )}
        </>
    );
}

function ExternalRewardsClaimDetails({ reward }: { reward: UserExternalRewardsInfoExpanded | undefined }) {
    const { vaultExpanded } = useVaultContext();
    const { getOracle } = useOraclePrices([reward?.rewardMint]);

    const usdPrice = getOracle(reward?.rewardMint)?.usdPrice;
    const tokenPrice = (reward?.pendingRewards ?? 0) * (usdPrice ?? 0);

    const claimMints = useMemo(() => {
        if (!reward) return [];
        return [reward.rewardMint];
    }, [reward]);

    if (!reward || reward.pendingRewards === 0) {
        return null;
    }

    return (
        <Row spaceBetween>
            <Row spacing={1}>
                <TokenImage metadata={reward?.rewardMetadata} />
                <Column>
                    <Text loading={!reward}>
                        {formatTokenAmount(reward?.pendingRewards, reward?.rewardMetadata ?? {})}
                    </Text>
                    <Text color="caption" variant="body2" loading={!reward}>
                        {formatUsd(tokenPrice)}
                    </Text>
                </Column>
            </Row>
            <Column>
                <VaultExternalRewardsClaimCta
                    loading={!reward}
                    shortText
                    claimMints={claimMints}
                    vaultExpanded={vaultExpanded}
                />
            </Column>
        </Row>
    );
}
